<template>
  <div id="app-user">
    <div class="user_container">
      <div class="content">
        <div class="con-1" ref="codeRef" v-if="indexItem == 0">
          <img src="@/assets/user/bill2.png" alt="" />
          <div class="con-1-box">
            <p class="con-1-p1">
              <span>{{ obj.positionName }}</span>
              <span class="payRange" v-if="obj.payRange && obj.payRange!=='null-null'"
                >{{ obj.payRange }}万</span
              >
              <span class="nopayRange" v-else>面议</span>
            </p>
            <p class="con-1-p2">{{ obj.workAddr }}</p>
            <p class="con-1-p3">{{ obj.orgname }}</p>
            <img :src="obj.imgUrl" alt="" />
            <!-- <p class="con-1-p4">“我是{{ obj.empName }},我来为您推荐~”</p> -->
            <p class="con-1-p4">我们正在招聘，诚邀加入我们！</p>
            <div class="bookcode" id="qrcode"></div>
          </div>
        </div>
        <div class="con-2" ref="codeRef" v-if="indexItem == 1">
          <img src="@/assets/user/bill3.png" alt="" />
          <div class="con-2-box">
            <dl>
              <dt><img :src="obj.imgUrl" alt="" /></dt>
              <!-- <dd>“我是{{ obj.empName }},我来为您推荐~”</dd> -->
              <dd>我们正在招聘，诚邀加入我们！</dd>
            </dl>
            <div>
              <span>{{ obj.positionName }}</span>
              <span class="payRange" v-if="obj.payRange && obj.payRange!=='null-null'"
                >{{ obj.payRange }}万</span
              >
              <span class="nopayRange" v-else>面议</span>
            </div>
            <div>{{ obj.workAddr }}<span>|</span>{{ obj.orgname }}</div>
            <div class="bookcode" id="qrcode"></div>
          </div>
        </div>
        <div class="con-3" ref="codeRef" v-if="indexItem == 2">
          <img src="@/assets/user/bill1.png" alt="" />
          <div class="con-3-box">
            <dl>
              <dt><img :src="obj.imgUrl" alt="" /></dt>
              <!-- <dd>“我是{{ obj.empName }},我来为您推荐~”</dd> -->
              <dd>我们正在招聘，诚邀加入我们！</dd>
            </dl>
            <p class="con-3-p1">
              <span>{{ obj.positionName }}</span>
              <span class="payRange" v-if="obj.payRange && obj.payRange!=='null-null'"
                >{{ obj.payRange }}万</span
              >
              <span class="nopayRange" v-else>面议</span>
            </p>
            <p class="con-3-p2">{{ obj.workAddr }}</p>
            <p class="con-3-p3">{{ obj.orgname }}</p>
            <div class="bookcode" id="qrcode"></div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div v-for="(item, index) in billmenu" :key="index">
          <img
            @click="setImg(index)"
            :class="{ active: index == indexItem }"
            :src="item"
            alt=""
          />
        </div>
      </div>
      <div class="button">
        <van-button @click="noUrl">取消</van-button>
        <van-button @click="download">生成海报</van-button>
      </div>
      <div class="menu">
        <van-overlay :show="iframe" @click="iframe = false">
          <div class="m-box">
            <span>长按保存图片</span>
            <div class="m-cross"></div>
            <div class="m-cross-up"></div>
          </div>
          <img :src="img" alt="" />
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import billmenu1 from "@/assets/user/billmenu1.png";
import billmenu2 from "@/assets/user/billmenu2.png";
import billmenu3 from "@/assets/user/billmenu3.png";
import api from "@/apis/user";
import { getToken } from "@/utils/cookie";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import DeviceDetector from "device-detector-js";
import { setDevice } from "@/utils/cookie";
export default {
  name: "HR",
  data() {
    return {
      billmenu: [billmenu1, billmenu2, billmenu3],
      indexItem: 0,
      positionId: "",
      obj: {},
      flag: false,
      img: "",
      iframe: false,
    };
  },
  created() {},
  mounted() {
    this.positionId = this.$route.query.id;
    this.getList();
    this.redirectRoute();
  },
  methods: {
    //获取设备信息
    redirectRoute() {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];

      const deviceDetector = new DeviceDetector();
      let device = deviceDetector.parse(userAgentInfo);
      setDevice(
        device.device.brand + " " + device.os.name + " " + device.client.name
      );

      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.flag = true;
          break;
        }
      }
    },
    //下载
    download() {
      if (this.flag) {
        html2canvas(this.$refs.codeRef).then((canvas) => {
          // this.$refs.addImage.append(canvas);//在下面添加canvas节点
          let link = document.createElement("a");
          link.href = canvas.toDataURL(); //下载链接
          link.setAttribute("download", "海报.png");
          link.style.display = "none"; //a标签隐藏
          document.body.appendChild(link);
          this.iframe = true;
          this.img = link.href;
        });
      } else {
        html2canvas(this.$refs.codeRef, {
          imageTimeout: 15000, //newline
          scale: 3, //newline
          useCORS: true,
        }).then(function (canvas) {
          var imageURL = canvas.toDataURL("image/jpg");
          let a = document.createElement("a");
          a.href = imageURL;
          a.download = "海报.jpg";
          a.click();
        });
      }
    },
    //生成二维码
    qrcode() {
      let str = document.documentElement.clientWidth;
      if (str > 380) {
        str = 380;
      } else {
        str = document.documentElement.clientWidth;
      }
      let long = str * (73 / 375);
      let qrcode = new QRCode("qrcode", {
        width: long, //图像宽度
        height: long, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.L,
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(this.obj.detailUrl);
    },
    //返回
    noUrl() {
      this.$router.go(-1);
    },
    setImg(index) {
      this.indexItem = index;
    },
    //获取数据
    getList() {
      api
        .selectUserPositionDetail({
          positionId: this.positionId,
          empNo: getToken(),
        })
        .then((data) => {
          this.$nextTick(() => {
            this.obj = data.data;
            this.qrcode();
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-user {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-user {
    width: 276px * $zoom;
  }
  .con-1,
  .con-2,
  .con-3 {
    margin-top: 120px !important;
    width: 100% !important;
    height: 80% !important;
    img {
      width: 100%;
    }
  }
}
#app-user {
  font-size: 16px * $zoom;
  position: relative;
  .user_container {
    width: 100%;
    height: 100vh;
    background: #f7f9fa;
    display: flex;
    flex-direction: column;
    .content {
      width: 100%;
      flex: 1;
      padding: 40px 50px;
      .con-1,
      .con-2,
      .con-3 {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .con-1 {
        position: relative;
        .con-1-box {
          .con-1-p1 {
            span:nth-child(1) {
              font-size: 36px;
              font-weight: 600;
              position: absolute;
              top: 32%;
              left: 15%;
            }
            .payRange {
              position: absolute;
              top: 32%;
              left: 48%;
              width: 250px;
              text-align: right;
              font-size: 36px;
              font-weight: 600;
              color: #c62e42;
            }
            .nopayRange {
              position: absolute;
              top: 32%;
              left: 72%;
              font-size: 36px;
              font-weight: 600;
              color: #c62e42;
            }
          }
          .con-1-p2 {
            position: absolute;
            top: 38%;
            left: 15%;
            font-size: 30px;
            color: #647083;
          }
          .con-1-p3 {
            position: absolute;
            top: 43%;
            left: 15%;
            font-size: 30px;
            color: #647083;
          }
          img {
            position: absolute;
            top: 53%;
            left: 15%;
            width: 70px;
            height: 70px;
            border-radius: 50%;
          }
          .con-1-p4 {
            position: absolute;
            top: 62%;
            left: 15%;
            width: 270px;
            font-size: 32px;
            line-height: 50px;
          }
          .bookcode {
            position: absolute;
            top: 85%;
            left: 60%;
          }
        }
      }
      .con-2 {
        position: relative;
        .con-2-box {
          dl {
            img {
              position: absolute;
              top: 48%;
              left: 6%;
              width: 70px;
              height: 70px;
              border-radius: 50%;
            }
            dd {
              position: absolute;
              top: 47.5%;
              left: 20%;
              width: 270px;
              font-size: 32px;
            }
          }
          div:nth-child(2) {
            span:nth-child(1) {
              color: #fff;
              background: #093e2e;
              padding: 5px 20px;
              border-radius: 10px;
              font-size: 30px;
              position: absolute;
              top: 58%;
              left: 6%;
            }
            .nopayRange {
              color: #cf4244;
              font-size: 32px;
              font-weight: 600;
              position: absolute;
              top: 58.5%;
              left: 64%;
            }
            .payRange {
              color: #cf4244;
              font-size: 32px;
              font-weight: 600;
              position: absolute;
              width: 250px;
              text-align: right;
              top: 58.5%;
              left: 38%;
            }
          }
          div:nth-child(3) {
            font-size: 32px;
            color: #647083;
            display: flex;
            align-items: center;
            position: absolute;
            top: 65.5%;
            left: 6%;
            span {
              margin: 0 15px;
            }
          }
          .bookcode {
            position: absolute;
            top: 85%;
            left: 71%;
          }
        }
      }
      .con-3 {
        position: relative;
        .con-3-box {
          dl {
            img {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              position: absolute;
              top: 47%;
              left: 16%;
            }
            dd {
              width: 270px;
              font-size: 32px;
              margin-left: 20px;
              position: absolute;
              top: 46.5%;
              left: 26%;
            }
          }
          .con-3-p1 {
            span:nth-child(1) {
              font-size: 36px;
              font-weight: 600;
              position: absolute;
              top: 61%;
              left: 16%;
            }
            .nopayRange {
              font-size: 36px;
              font-weight: 600;
              color: #c62e42;
              position: absolute;
              top: 61%;
              left: 74%;
            }
            .payRange {
              font-size: 36px;
              font-weight: 600;
              color: #c62e42;
              position: absolute;
              width: 250px;
              text-align: right;
              top: 61%;
              left: 47%;
            }
          }
          .con-3-p2 {
            font-size: 30px;
            color: #647083;
            position: absolute;
            top: 67%;
            left: 16%;
          }
          .con-3-p3 {
            font-size: 30px;
            color: #647083;
            position: absolute;
            top: 72%;
            left: 16%;
          }
          .bookcode {
            position: absolute;
            top: 85%;
            left: 71%;
          }
        }
      }
    }
    .footer {
      width: 100%;
      height: 300px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 150px;
        height: 180px;
        margin-right: 20px;
      }
      .active {
        border: 6px solid rgba(78, 162, 124, 1);
        border-radius: 15px;
      }
    }
    .button {
      width: 100%;
      height: 120px;
      display: flex;
      button:nth-child(1) {
        width: 35%;
        height: 100%;
        border-top: 1px solid #ccc;
      }
      button:nth-child(2) {
        flex: 1;
        height: 100%;
        background: rgba(78, 162, 124, 1);
        color: #fff;
      }
    }
    .menu {
      img {
        width: 90%;
        height: 75%;
        margin-left: 5%;
        margin-top: 3%;
        border-radius: 25px;
      }
      .m-box {
        margin-top: 50px;
        margin-left: 50%;
        position: relative;
        width: 330px;
        height: 100px;
        line-height: 100px;
        background: #f6f1b3;
        box-shadow: 0px 0px 3px #e9d985;
        border: 1px solid #dace7c;
        border-radius: 15px;
        text-align: center;
        color: black;
        font-size: 32px;
      }

      .m-cross {
        position: absolute;
        top: 92px;
        left: 30px;
        overflow: hidden;
        width: 13px;
        height: 13px;
        background: #f6f1b3;
        border-left: 1px solid #dace7c;
        border-top: 1px solid #dace7c;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
        filter: drop-shadow(0px 0px 3px #e9d985);
        z-index: -1;
      }
      .m-cross-up {
        position: absolute;
        top: 92px;
        left: 30px;
        overflow: hidden;
        width: 13px;
        height: 13px;
        background: #f6f1b3;
        border-right: 1px solid #dace7c;
        border-bottom: 1px solid #dace7c;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
  }
}
</style>
